import DownPayment from "../DownPayment";
import CreditRatingSelect from "../CreditRatingSelect";
import TermSlider from "../TermSlider";
import Deposit from "../Deposit";

export default function NewContractForm() {
  return (
    <React.Fragment>
      <TermSlider />
      <DownPayment />
      <Deposit />
      <CreditRatingSelect />
    </React.Fragment>
  );
}


// WEBPACK FOOTER //
// blocks/quote-calculator/app/components/LoanOptions/components/forms/NewContractForm.js